'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Vas = require('../Vas');

var _Vas2 = _interopRequireDefault(_Vas);

require('../css/AutocompleteField.css');

require('../css/ControlBase.css');

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _MessageBox = require('./MessageBox');

var _MessageBox2 = _interopRequireDefault(_MessageBox);

var _utilsLib = require('utils-lib');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*code von https://www.w3schools.com/howto/howto_js_autocomplete.asp 27.06.2018*/

/*
Pflichtproperties:
AppURL={Vas.ApplicationUrl} 
TitleMessageFalseStreet={Vas.Resources.Labels["Error"]} 
MessageFalseStreet={Vas.Resources.Labels["FalseStreet"]/Vas.Resources.Labels["FalseProduct"]}  
Modus={"Street/TariffPoint"}  
Id={"Street"}  
IsRequired={true/false} 
editable={true/false} 
Label={Vas.Resources.Labels["Street"]} 
Data={this.state.streets} 

optional:
Width={358} ref={"street"} Float={'left'}
OnBlur={()=>{this.setState({Street: $("#Street").val()}) }} Tooltip={Vas.Resources.Tooltips["Street"]}
Autocomplete={false/true}=>"off"/"on"
*/

var AutocompleteField = function (_Component) {
    _inherits(AutocompleteField, _Component);

    function AutocompleteField(props) {
        _classCallCheck(this, AutocompleteField);

        var _this = _possibleConstructorReturn(this, (AutocompleteField.__proto__ || Object.getPrototypeOf(AutocompleteField)).call(this, props));

        _this.state = {};
        _this.state.Label = _this.props.Label;
        _this.state.Data = _this.props.Data;
        _this.state.isrequired = _this.props.IsRequired;
        _this.state.required = true;
        _this.state.close = false;
        _this.state.count = 0;
        _this.state.editable = _this.props.editable;
        _this.state.OnChange = _this.props.OnChange;
        _this.state.Function = _this.props.Function;
        _this.state.placeholder = _this.props.placeholder;
        _this.state.autocomplete = _this.props.Autocomplete;
        _this.Timeout = '';
        _this.state.TimeOutTime = _this.props.TimeOutTime;
        _this.state.ClearFunction = _this.props.ClearFunction;
        _this.state.OnFocus = _this.props.OnFocus;
        _this.state.HintAutoComplete = _this.props.HintAutoComplete;
        _this.FindStrFromStreets = _this.props.FindStrFromStreets !== null && _this.props.FindStrFromStreets !== undefined ? _this.props.FindStrFromStreets : false;
        _this.SubstringsAllowed = _this.props.SubstringsAllowed !== null && _this.props.SubstringsAllowed !== undefined ? _this.props.SubstringsAllowed : false;

        _this.eventListenerKeyDownExists = false;
        return _this;
    }

    _createClass(AutocompleteField, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.Modus) {
                if (this.props.Modus === "TariffPoint") {
                    if (this.state.Data) {
                        var arr = this.state.Data;
                        var inp = document.getElementById(this.props.Id);
                        this.autocomplete(inp, arr, this);
                    }
                }
            }
        }
    }, {
        key: 'tab',
        value: function tab(event, me) {
            if (event) {
                if (event.keyCode === 13 || event.keyCode === 9) {

                    //close all autocomplete lists in the document
                    var x = document.getElementsByClassName("autocomplete-items");
                    for (var _i = 0; _i < x.length; _i++) {
                        x[_i].parentNode.removeChild(x[_i]);
                    }

                    (0, _jquery2.default)("#" + me.props.Id).val(_utilsLib.XssFilter.getText((0, _jquery2.default)("#" + me.props.Id).val()));
                    var docs = document.querySelectorAll('input,button, div.ss-selected-option,select');
                    var maxId = docs.length;
                    var aktive = document.activeElement.id;
                    var i = void 0;

                    for (i = 0; i < maxId - 1; i++) {
                        if (docs[i].id === aktive) {
                            if (event.shiftKey && event.keyCode === 9) {
                                for (var j = i - 1; j >= 0; j--) {
                                    if (!docs[j].readOnly) {
                                        docs[j].focus();
                                        break;
                                    } else if (docs[j].className === "ss-selected-option") {
                                        var _event = new Event("click");
                                        docs[j].dispatchEvent(_event);
                                        break;
                                    }
                                }
                            } else {
                                for (var _j = i + 1; _j <= maxId - 1; _j++) {
                                    if (!docs[_j].readOnly) {
                                        docs[_j].focus();
                                        break;
                                    } else if (docs[_j].className === "ss-selected-option") {
                                        var _event2 = new Event("click");
                                        docs[_j].dispatchEvent(_event2);
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    me.getFilled(me);
                } else if (event.keyCode === undefined) {
                    if (!event.keyCode) {
                        (0, _jquery2.default)("#" + me.props.Id).val(_utilsLib.XssFilter.getText((0, _jquery2.default)("#" + me.props.Id).val()));
                        me.getFilled(me);
                    }
                } else if (event.keyCode === 8 || event.keyCode === 46) {
                    if ((0, _jquery2.default)("#" + me.props.Id).val().length === 1) {
                        me.setState({ placeholder: null });
                    }
                }
            }
        }
    }, {
        key: 'getFilled',
        value: function getFilled(me) {
            var filled = true;
            if (me.state.isrequired) {
                if ((0, _jquery2.default)("#" + me.props.Id).val().length === 0) {
                    filled = false;
                } else {
                    filled = true;
                    if (me.state.Data) {
                        if (me.state.Data.length !== 0) {
                            if (filled === true) {
                                filled = me.checkField(me);
                            }
                        }
                    }
                }
            }
            me.setState({ required: filled });
        }
    }, {
        key: 'checkField',
        value: function checkField(me) {
            //nach Verlassen des Feldes mit TariffPoint, prüfen, ob ein gültiger TariffPoint ausgewählt wurde
            var valid = true;
            if (me.props.Modus === "TariffPoint") {
                var val = (0, _jquery2.default)("#" + me.props.Id).val();
                if (val.length > 0) {
                    valid = false;
                    if (me.state.Data) {
                        var values = me.state.Data;
                        if (values.length > 0) {
                            for (var i = 0; i < values.length; i++) {
                                if (values[i] === val) {
                                    valid = true;
                                }
                            }
                        }
                        if (valid === false) {
                            _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
                                AppURL: me.props.AppURL,
                                Title: me.props.TitleMessageFalseStreet ? me.props.TitleMessageFalseStreet : _Vas2.default.getText('Titles', 'Note'),
                                Message: me.props.MessageFalseStreet ? me.props.MessageFalseStreet : _Vas2.default.getText('Labels', 'FalseProduct'),
                                Click: function Click() {
                                    (0, _jquery2.default)("#" + me.props.Id).val('');
                                    if (me.props.ClickFalseProduct) {
                                        me.props.ClickFalseProduct();
                                    }
                                },
                                Field: me.props.Id
                            }), document.getElementById('messageContainer'));

                            me.setState({ required: valid, Data: [] });
                        } else {
                            me.setState({ required: valid });
                        }
                    }
                }
            } else {}
            return valid;
        }
        //#region autocomplete "normal"

    }, {
        key: 'autocomplete',
        value: function autocomplete(inp, arr, me) {
            var _this2 = this;

            /*the autocomplete function takes two arguments,
             the text field element and an array of possible autocompleted values:*/
            var currentFocus = void 0;
            if (arr) {
                var valArray;
                var valArray0;
                var valArray1;
                var res1;
                var res2;
                var valArray;
                var res1;
                var res2;
                var valStr;
                var res;
                var res;

                var _ret = function () {
                    var addActive = function addActive(x) {

                        /*a function to classify an item as "active":*/
                        if (!x) {
                            return false;
                        }
                        /*start by removing the "active" class on all items:*/
                        if (currentFocus >= 0) {
                            removeActive(x);
                            if (currentFocus >= x.length) {
                                currentFocus = 0;
                            }
                            if (currentFocus < 0) {
                                currentFocus = x.length - 1;
                            }

                            /*add class "autocomplete-active":*/
                            if (me.state.Data.length === 1) {
                                x[currentFocus].click();
                                closeAllLists(me);
                            } else {
                                x[currentFocus].classList.add("autocomplete-active");
                            }
                        }
                    };

                    var removeActive = function removeActive(x) {
                        /*a function to remove the "active" class from all autocomplete items:*/
                        for (var _i2 = 0; _i2 < x.length; _i2++) {
                            x[_i2].classList.remove("autocomplete-active");
                        }
                    };

                    var closeAllLists = function closeAllLists(elmnt) {
                        /*close all autocomplete lists in the document,
                        except the one passed as an argument:*/
                        var x = document.getElementsByClassName("autocomplete-items");
                        for (var _i3 = 0; _i3 < x.length; _i3++) {
                            if (elmnt !== x[_i3] && elmnt !== inp) {
                                x[_i3].parentNode.removeChild(x[_i3]);
                            }
                        }
                    };

                    /*execute a function when someone clicks in the document:*/


                    if (me.props.Modus === "TariffPoint") {
                        var a = void 0,
                            b = void 0,
                            i = void 0,
                            val = inp.value;
                        if (me.state.count === 0) {
                            me.setState({ count: me.state.count + 1 });
                        }
                        if (me.state.close === false) {

                            /*close any already open lists of autocompleted values*/
                            closeAllLists(null, me);
                            if (!val) {
                                return {
                                    v: false
                                };
                            }
                            currentFocus = -1;
                            /*create a DIV element that will contain the items (values):*/
                            a = document.createElement("DIV");
                            a.setAttribute("id", inp.id + "autocomplete-list");
                            a.setAttribute("class", "autocomplete-items");
                            /*append the DIV element as a child of the autocomplete container:*/
                            inp.parentNode.appendChild(a);
                            /*for each item in the array...*/
                            for (i = 0; i < arr.length; i++) {
                                /*check if the item starts with the same letters as the text field value:*/
                                //if (arr[i].substr(0, val.length).toUpperCase() === val.toUpperCase()) {

                                //val prüfen, wenn " ", dann splitt und zwei Checks
                                if (val.indexOf(" ") > -1 && _this2.SubstringsAllowed) {
                                    if (_this2.FindStrFromStreets) {
                                        valArray = val.split(" ");
                                        valArray0 = valArray[0].toLowerCase().indexOf("straße") > -1 ? valArray[0].toLowerCase().replace("straße", "str") : valArray[0].toLowerCase().indexOf("strasse") > -1 ? valArray[0].toLowerCase().replace("strasse", "str") : valArray[0].toLowerCase();
                                        valArray1 = valArray[1].toLowerCase().indexOf("straße") > -1 ? valArray[1].toLowerCase().replace("straße", "str") : valArray[1].toLowerCase().indexOf("strasse") > -1 ? valArray[1].toLowerCase().replace("strasse", "str") : valArray[1].toLowerCase();
                                        res1 = _utilsLib.CheckValues.includes(arr[i].toLowerCase(), valArray0.toLowerCase());
                                        res2 = _utilsLib.CheckValues.includes(arr[i].toLowerCase(), valArray1.toLowerCase());


                                        if (res1[0] == true && res2[0] == true) {
                                            /*create a DIV element for each matching element:*/
                                            b = document.createElement("DIV");
                                            /*make the matching letters bold:*/

                                            if (res1[1] < res2[1]) {
                                                if (res1[1] == 0) {
                                                    b.innerHTML += "<strong>" + arr[i].substr(0, valArray0.length) + "</strong>";
                                                    b.innerHTML += arr[i].substr(res1[1] + valArray0.length, res2[1] - res1[1] - valArray0.length);
                                                    b.innerHTML += "<strong>" + arr[i].substr(res2[1], valArray1.length) + "</strong>";

                                                    if (arr[i].substr(res2[1]).length > valArray1.length) {
                                                        b.innerHTML += arr[i].substr(res2[1] + valArray1.length);
                                                    }
                                                } else {
                                                    b.innerHTML = arr[i].substr(0, res1[1]);
                                                    b.innerHTML += "<strong>" + arr[i].substr(res1[1], valArray0.length) + "</strong>";
                                                    b.innerHTML += arr[i].substr(res1[1] + valArray0.length, res2[1] - res1[1] - valArray0.length);
                                                    b.innerHTML += "<strong>" + arr[i].substr(res2[1], valArray1.length) + "</strong>";

                                                    if (arr[i].substr(res2[1]).length > valArray1.length) {
                                                        b.innerHTML += arr[i].substr(res2[1] + valArray1.length);
                                                    }
                                                }
                                            } else if (res1[1] > res2[1]) {
                                                if (res2[1] == 0) {
                                                    b.innerHTML += "<strong>" + arr[i].substr(0, valArray1.length) + "</strong>";
                                                    b.innerHTML += arr[i].substr(res2[1] + valArray1.length, res1[1] - valArray1.length);
                                                    b.innerHTML += "<strong>" + arr[i].substr(res1[1], valArray0.length) + "</strong>";

                                                    if (arr[i].substr(res2[1]).length > valArray1.length) {
                                                        b.innerHTML += arr[i].substr(res1[1] + valArray0.length);
                                                    }
                                                } else {
                                                    b.innerHTML = arr[i].substr(0, res2[1]);
                                                    b.innerHTML += "<strong>" + arr[i].substr(res2[1], valArray1.length) + "</strong>";
                                                    b.innerHTML += arr[i].substr(res2[1] + valArray1.length, res1[1] - res2[1] - valArray1.length);
                                                    b.innerHTML += "<strong>" + arr[i].substr(res1[1], valArray0.length) + "</strong>";

                                                    if (arr[i].substr(res1[1]).length > valArray1.length) {
                                                        b.innerHTML += arr[i].substr(res1[1] + valArray0.length);
                                                    }
                                                }
                                            } else {

                                                if (res1[1] == 0) {
                                                    b.innerHTML += "<strong>" + arr[i].substr(0, valArray0.length) + "</strong>";
                                                    b.innerHTML += arr[i].substr(res1[1] + valArray0.length, res1[1] - valArray0.length);

                                                    if (arr[i].substr(res1[1]).length > valArray1.length) {
                                                        b.innerHTML += arr[i].substr(res1[1] + valArray0.length);
                                                    }
                                                } else {
                                                    b.innerHTML = arr[i].substr(0, res1[1]);
                                                    b.innerHTML += "<strong>" + arr[i].substr(res1[1], valArray1.length) + "</strong>";
                                                    b.innerHTML += arr[i].substr(res1[1] + valArray1.length);
                                                }
                                            }

                                            /*insert a input field that will hold the current array item's value:*/
                                            b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
                                            /*execute a function when someone clicks on the item value (DIV element):*/
                                            // eslint-disable-next-line
                                            b.addEventListener("click", function (e) {
                                                /*insert the value for the autocomplete text field:*/
                                                inp.value = this.getElementsByTagName("input")[0].value;
                                                /*close the list of autocompleted values,
                                                (or any other open lists of autocompleted values:*/

                                                closeAllLists(null, me);
                                                if (me !== document) {
                                                    me.setState({ close: true });
                                                }
                                                currentFocus = -1;

                                                if (me.state.Function) {
                                                    me.state.Function();
                                                }

                                                me.getFilled(me);
                                            });
                                            a.appendChild(b);
                                        }
                                    } else {
                                        valArray = val.split(" ");
                                        res1 = _utilsLib.CheckValues.includes(arr[i].toLowerCase(), valArray[0].toLowerCase());
                                        res2 = _utilsLib.CheckValues.includes(arr[i].toLowerCase(), valArray[1].toLowerCase());


                                        if (res1[0] == true && res2[0] == true) {
                                            /*create a DIV element for each matching element:*/
                                            b = document.createElement("DIV");
                                            /*make the matching letters bold:*/

                                            if (res1[1] < res2[1]) {
                                                if (res1[1] == 0) {
                                                    b.innerHTML += "<strong>" + arr[i].substr(0, valArray[0].length) + "</strong>";
                                                    b.innerHTML += arr[i].substr(res1[1] + valArray[0].length, res2[1] - res1[1] - valArray[0].length);
                                                    b.innerHTML += "<strong>" + arr[i].substr(res2[1], valArray[1].length) + "</strong>";

                                                    if (arr[i].substr(res2[1]).length > valArray[1].length) {
                                                        b.innerHTML += arr[i].substr(res2[1] + valArray[1].length);
                                                    }
                                                } else {
                                                    b.innerHTML = arr[i].substr(0, res1[1]);
                                                    b.innerHTML += "<strong>" + arr[i].substr(res1[1], valArray[0].length) + "</strong>";
                                                    b.innerHTML += arr[i].substr(res1[1] + valArray[0].length, res2[1] - res1[1] - valArray[0].length);
                                                    b.innerHTML += "<strong>" + arr[i].substr(res2[1], valArray[1].length) + "</strong>";

                                                    if (arr[i].substr(res2[1]).length > valArray[1].length) {
                                                        b.innerHTML += arr[i].substr(res2[1] + valArray[1].length);
                                                    }
                                                }
                                            } else if (res1[1] > res2[1]) {
                                                if (res2[1] == 0) {
                                                    b.innerHTML += "<strong>" + arr[i].substr(0, valArray[1].length) + "</strong>";
                                                    b.innerHTML += arr[i].substr(res2[1] + valArray[1].length, res1[1] - valArray[1].length);
                                                    b.innerHTML += "<strong>" + arr[i].substr(res1[1], valArray[0].length) + "</strong>";

                                                    if (arr[i].substr(res2[1]).length > valArray[1].length) {
                                                        b.innerHTML += arr[i].substr(res1[1] + valArray[0].length);
                                                    }
                                                } else {
                                                    b.innerHTML = arr[i].substr(0, res2[1]);
                                                    b.innerHTML += "<strong>" + arr[i].substr(res2[1], valArray[1].length) + "</strong>";
                                                    b.innerHTML += arr[i].substr(res2[1] + valArray[1].length, res1[1] - res2[1] - valArray[1].length);
                                                    b.innerHTML += "<strong>" + arr[i].substr(res1[1], valArray[0].length) + "</strong>";

                                                    if (arr[i].substr(res1[1]).length > valArray[1].length) {
                                                        b.innerHTML += arr[i].substr(res1[1] + valArray[0].length);
                                                    }
                                                }
                                            } else {

                                                if (res1[1] == 0) {
                                                    b.innerHTML += "<strong>" + arr[i].substr(0, valArray[0].length) + "</strong>";
                                                    b.innerHTML += arr[i].substr(res1[1] + valArray[0].length, res1[1] - valArray[0].length);

                                                    if (arr[i].substr(res1[1]).length > valArray[1].length) {
                                                        b.innerHTML += arr[i].substr(res1[1] + valArray[0].length);
                                                    }
                                                } else {
                                                    b.innerHTML = arr[i].substr(0, res1[1]);
                                                    b.innerHTML += "<strong>" + arr[i].substr(res1[1], valArray[1].length) + "</strong>";
                                                    b.innerHTML += arr[i].substr(res1[1] + valArray[1].length);
                                                }
                                            }

                                            /*insert a input field that will hold the current array item's value:*/
                                            b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
                                            /*execute a function when someone clicks on the item value (DIV element):*/
                                            // eslint-disable-next-line
                                            b.addEventListener("click", function (e) {
                                                /*insert the value for the autocomplete text field:*/
                                                inp.value = this.getElementsByTagName("input")[0].value;
                                                /*close the list of autocompleted values,
                                                (or any other open lists of autocompleted values:*/

                                                closeAllLists(null, me);
                                                if (me !== document) {
                                                    me.setState({ close: true });
                                                }
                                                currentFocus = -1;

                                                if (me.state.Function) {
                                                    me.state.Function();
                                                }

                                                me.getFilled(me);
                                            });
                                            a.appendChild(b);
                                        }
                                    }
                                } else {
                                    if (_this2.FindStrFromStreets) {
                                        valStr = val.toLowerCase().indexOf("straße") > -1 ? val.toLowerCase().replace("straße", "str") : val.toLowerCase().indexOf("strasse") > -1 ? val.toLowerCase().replace("strasse", "str") : val.toLowerCase();
                                        res = _utilsLib.CheckValues.includes(arr[i].toUpperCase(), valStr.toUpperCase()); //prüft, ob Item die gleichen Buchstaben wie der eingegebene Text beinhaltet

                                        if (res[0] === true) {
                                            /*create a DIV element for each matching element:*/
                                            b = document.createElement("DIV");
                                            /*make the matching letters bold:*/
                                            b.innerHTML = arr[i].substr(0, res[1]);
                                            b.innerHTML += "<strong>" + arr[i].substr(res[1], valStr.length) + "</strong>";
                                            b.innerHTML += arr[i].substr(res[1] + valStr.length);

                                            /*insert a input field that will hold the current array item's value:*/
                                            b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
                                            /*execute a function when someone clicks on the item value (DIV element):*/
                                            // eslint-disable-next-line
                                            b.addEventListener("click", function (e) {
                                                /*insert the value for the autocomplete text field:*/
                                                inp.value = this.getElementsByTagName("input")[0].value;
                                                /*close the list of autocompleted values,
                                                (or any other open lists of autocompleted values:*/

                                                closeAllLists(null, me);
                                                if (me !== document) {
                                                    me.setState({ close: true });
                                                }
                                                currentFocus = -1;

                                                if (me.state.Function) {
                                                    me.state.Function();
                                                }

                                                me.getFilled(me);
                                            });
                                            a.appendChild(b);
                                        }
                                    } else {
                                        res = _utilsLib.CheckValues.includes(arr[i].toUpperCase(), val.toUpperCase()); //prüft, ob Item die gleichen Buchstaben wie der eingegebene Text beinhaltet

                                        if (res[0] === true) {
                                            /*create a DIV element for each matching element:*/
                                            b = document.createElement("DIV");
                                            /*make the matching letters bold:*/
                                            b.innerHTML = arr[i].substr(0, res[1]);
                                            b.innerHTML += "<strong>" + arr[i].substr(res[1], val.length) + "</strong>";
                                            b.innerHTML += arr[i].substr(res[1] + val.length);

                                            /*insert a input field that will hold the current array item's value:*/
                                            b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
                                            /*execute a function when someone clicks on the item value (DIV element):*/
                                            // eslint-disable-next-line
                                            b.addEventListener("click", function (e) {
                                                /*insert the value for the autocomplete text field:*/
                                                inp.value = this.getElementsByTagName("input")[0].value;
                                                /*close the list of autocompleted values,
                                                (or any other open lists of autocompleted values:*/

                                                closeAllLists(null, me);
                                                if (me !== document) {
                                                    me.setState({ close: true });
                                                }
                                                currentFocus = -1;

                                                if (me.state.Function) {
                                                    me.state.Function();
                                                }

                                                me.getFilled(me);
                                            });
                                            a.appendChild(b);
                                        }
                                    }
                                }
                            }
                            var x = document.getElementById(inp.id + "autocomplete-list");
                            if (x) {
                                x = x.getElementsByTagName("div");
                            }
                            currentFocus = 0;
                            if (x) {
                                if (x.length > 0) {
                                    addActive(x);
                                }
                            }
                        }

                        inp.addEventListener("input", function (e) {
                            if (me.state.close === true) {
                                currentFocus = -1;
                                me.setState({ close: false });
                            }
                        });

                        inp.addEventListener("focus", function (e) {
                            /*close any already open lists of autocompleted values*/
                            closeAllLists(null, me);

                            if (!val) {
                                return false;
                            }
                            currentFocus = -1;
                            /*create a DIV element that will contain the items (values):*/
                            a = document.createElement("DIV");
                            a.setAttribute("id", inp.id + "autocomplete-list");
                            a.setAttribute("class", "autocomplete-items");
                            /*append the DIV element as a child of the autocomplete container:*/
                            inp.parentNode.appendChild(a);
                            arr = me.state.Data ? me.state.Data : [];
                            /*for each item in the array...*/
                            for (i = 0; i < arr.length; i++) {
                                /*check if the item starts with the same letters as the text field value:*/
                                //if (arr[i].substr(0, val.length).toUpperCase() === val.toUpperCase()) {
                                var _res = _utilsLib.CheckValues.includes(arr[i].toUpperCase(), val.toUpperCase()); //prüft, ob Item die gleichen Buchstaben wie der eingegebene Text beinhaltet
                                if (_res[0] === true) {
                                    /*create a DIV element for each matching element:*/
                                    b = document.createElement("DIV");
                                    /*make the matching letters bold:*/
                                    b.innerHTML = arr[i].substr(0, _res[1]);
                                    b.innerHTML += "<strong>" + arr[i].substr(_res[1], val.length) + "</strong>";
                                    b.innerHTML += arr[i].substr(_res[1] + val.length);
                                    /*insert a input field that will hold the current array item's value:*/
                                    b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
                                    /*execute a function when someone clicks on the item value (DIV element):*/
                                    // eslint-disable-next-line
                                    b.addEventListener("click", function (e) {
                                        /*insert the value for the autocomplete text field:*/
                                        inp.value = this.getElementsByTagName("input")[0].value;
                                        /*close the list of autocompleted values,
                                        (or any other open lists of autocompleted values:*/

                                        closeAllLists(null, me);
                                        if (me !== document) {
                                            me.setState({ close: true });
                                        }
                                        currentFocus = -1;

                                        if (me.state.Function) {
                                            me.state.Function();
                                        }

                                        me.getFilled(me);
                                    });
                                    a.appendChild(b);
                                }
                            }
                        });
                    } else {

                        /*execute a function when someone writes in the text field:*/
                        inp.addEventListener("input", function (e) {
                            var a = void 0,
                                b = void 0,
                                i = void 0,
                                val = this.value;
                            /*close any already open lists of autocompleted values*/
                            closeAllLists(null, this);
                            if (!val) {
                                return false;
                            }
                            currentFocus = -1;
                            /*create a DIV element that will contain the items (values):*/
                            a = document.createElement("DIV");
                            a.setAttribute("id", me.props.Id + "autocomplete-list");
                            a.setAttribute("class", "autocomplete-items");

                            /*append the DIV element as a child of the autocomplete container:*/
                            this.parentNode.appendChild(a);
                            /*for each item in the array...*/
                            for (i = 0; i < arr.length; i++) {
                                /*check if the item starts with the same letters as the text field value:*/
                                //if (arr[i].substr(0, val.length).toUpperCase() === val.toUpperCase()) {
                                var _res2 = _utilsLib.CheckValues.includes(arr[i].toUpperCase(), val.toUpperCase()); //prüft, ob Item die gleichen Buchstaben wie der eingegebene Text beinhaltet
                                if (_res2[0] === true) {
                                    /*create a DIV element for each matching element:*/
                                    b = document.createElement("DIV");
                                    /*make the matching letters bold:*/
                                    b.innerHTML = arr[i].substr(0, _res2[1]);
                                    b.innerHTML += "<strong>" + arr[i].substr(_res2[1], val.length) + "</strong>";
                                    b.innerHTML += arr[i].substr(_res2[1] + val.length);
                                    /*insert a input field that will hold the current array item's value:*/
                                    b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
                                    /*execute a function when someone clicks on the item value (DIV element):*/
                                    b.addEventListener("click", function (e) {
                                        e.preventDefault();
                                        /*insert the value for the autocomplete text field:*/
                                        inp.value = this.getElementsByTagName("input")[0].value;
                                        if (me.props.OnBlur) {
                                            me.props.OnBlur();
                                        }
                                        /*close the list of autocompleted values,
                                        (or any other open lists of autocompleted values:*/
                                        closeAllLists(null, this);
                                        me.getFilled(me);
                                    });
                                    a.appendChild(b);
                                }
                            }
                            var x = document.getElementById(this.id + "autocomplete-list");
                            if (x) {
                                x = x.getElementsByTagName("div");
                            }
                            currentFocus = 0;
                            if (x) {
                                if (x.length > 0) {
                                    addActive(x);
                                }
                            }
                        });

                        inp.addEventListener("focus", function (e) {
                            var event = new CustomEvent("input");
                            inp.dispatchEvent(event);
                        });
                    }

                    if (me.eventListenerKeyDownExists === false) {
                        me.eventListenerKeyDownExists = true;
                        inp.addEventListener("keydown", function (e) {
                            // eslint-disable-next-line
                            if (currentFocus !== NaN) {
                                var _x = document.getElementById(this.id + "autocomplete-list");
                                if (_x) {
                                    _x = _x.getElementsByTagName("div");
                                }
                                if (e.keyCode === 40) {
                                    /*If the arrow DOWN key is pressed,
                                    increase the currentFocus variable:*/
                                    currentFocus++;

                                    /*and and make the current item more visible:*/
                                    addActive(_x);
                                } else if (e.keyCode === 38) {
                                    //up
                                    /*If the arrow UP key is pressed,
                                    decrease the currentFocus variable:*/
                                    currentFocus--;
                                    /*and and make the current item more visible:*/
                                    addActive(_x);
                                } else if (e.keyCode === 13 || e.keyCode === 9) {
                                    /*If the ENTER key is pressed, prevent the form from being submitted,*/
                                    e.preventDefault();
                                    if (currentFocus > -1) {
                                        /*and simulate a click on the "active" item:*/
                                        if (_x) {
                                            if (_x.length > 0) {
                                                _x[currentFocus].click();
                                            }
                                        }
                                    }
                                } else if (e.keyCode === 8) {//backspace
                                    //closeAllLists();
                                }
                            }
                        });
                    }

                    document.addEventListener("click", function (e) {
                        var nameOfClass = e.target.parentNode.className;
                        if (nameOfClass) {
                            var idx = nameOfClass.indexOf("-");
                            if (idx !== -1) {
                                nameOfClass = nameOfClass.substr(0, idx);
                            }
                            if (nameOfClass !== 'autocomplete') {
                                closeAllLists(e.target);
                            }
                        }
                    });
                }();

                if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
            }

            this.LogoClick();
        }

        //#endregion

    }, {
        key: 'Clear',
        value: function Clear() {

            //Hier zu ergänzen:
            //Wenn From geleert wird, dann To, Via und Price leeren und ausgrauen
            //Wenn To geleert wird, dann To, Via und Price leeren und ausgrauen

            var priceInfoText = document.getElementById('PriceInformation');

            var x = document.getElementsByClassName("autocomplete-items");
            for (var i = 0; i < x.length; i++) {
                x[i].parentNode.removeChild(x[i]);
            }

            if (priceInfoText != null) {
                if (document.getElementById('PriceInformation').children[0] != null) {
                    if (document.getElementById('PriceInformation').children[0].children[0] != null) {
                        document.getElementById('PriceInformation').children[0].children[0].innerHTML = this.props.PriceInfoText;
                    }
                }
            }

            var to = document.getElementById("To");
            var via = document.getElementById("Via");
            var product = null;
            if (document.getElementById("Product")) {
                product = document.getElementById("Product");
            }

            if (to !== null && via !== null) {

                if (this.props.Id === "From") {

                    (0, _jquery2.default)('#From').val('');
                    (0, _jquery2.default)('#To').val('');
                    (0, _jquery2.default)('#Via').val('');
                    (0, _jquery2.default)('#Price').val('');

                    if (product) {
                        (0, _jquery2.default)('#Product').val('');
                        product.style.backgroundColor = "lightgray";
                    }

                    if (!this.props.Project) {
                        to.style.backgroundColor = "lightgray";
                        via.style.backgroundColor = "lightgray";

                        to.className = "textfieldDisabled";
                        to.readOnly = "true";
                    } else {
                        if (this.props.Project != "DBBUS") {
                            to.style.backgroundColor = "lightgray";
                            via.style.backgroundColor = "lightgray";

                            to.className = "textfieldDisabled";
                            to.readOnly = "true";
                        }
                    }

                    this.setState({ Data: [] });

                    var toIcon = document.getElementById("To").nextSibling.childNodes[0];

                    if (toIcon != null) {
                        toIcon.style.display = "none";
                    }

                    if (this.state.ClearFunction) {
                        if (typeof this.state.ClearFunction === "function") {
                            this.state.ClearFunction();
                        }
                    }
                } else if (this.props.Id === "To") {
                    //Hier Via und Price leeren

                    (0, _jquery2.default)('#To').val('');
                    (0, _jquery2.default)('#Via').val('');
                    (0, _jquery2.default)('#Via option').hide();
                    (0, _jquery2.default)('#Price').val('');

                    if (product) {
                        (0, _jquery2.default)('#Product').val('');
                        product.style.backgroundColor = "lightgray";
                    }

                    if (!this.props.Project) {
                        via.style.backgroundColor = "lightgray";
                    } else {
                        if (this.props.Project != "DBBUS") {
                            via.style.backgroundColor = "lightgray";
                        }
                    }
                    //via.style.backgroundColor = "lightgray";

                    var price = document.getElementById("Price");
                    price.setAttribute("value", "");

                    this.setState({ Data: [] });

                    if (this.state.ClearFunction) {
                        if (typeof this.state.ClearFunction === "function") {
                            this.state.ClearFunction();
                        }
                    }
                } else {
                    (0, _jquery2.default)('#' + this.props.Id).val('');
                    this.setState({ Data: [] });
                }
            }
        }
    }, {
        key: 'focus',
        value: function focus(id) {
            if (this.state.placeholder) {
                if (this.state.placeholder.length > 0 && (0, _jquery2.default)("#" + id).val().length === 0) {
                    (0, _jquery2.default)("#" + id).val(this.state.placeholder);
                }
            }
            if (this.state.OnFocus) {
                this.state.OnFocus();
            }
        }
    }, {
        key: 'LogoClick',
        value: function LogoClick(condition) {

            var kontrastNumber = localStorage.getItem('Kontrast');

            if (kontrastNumber == "true") {

                (0, _jquery2.default)(".autocomplete-active").attr('style', 'background-color: #1d5c87 !important;');

                (0, _jquery2.default)(".autocomplete-items div").mouseenter(function () {
                    (0, _jquery2.default)(this).attr('style', 'background-color: #00375b !important; color: white;');
                }).mouseleave(function () {
                    (0, _jquery2.default)(this).attr('style', 'background-color: #FFFFFF !important; color: black;');
                    (0, _jquery2.default)(".autocomplete-active").attr('style', 'background-color: #1d5c87 !important;');
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var Tooltip = '';
            if (this.props.Tooltip && this.props.Tooltip !== "") {
                Tooltip = _react2.default.createElement(
                    'span',
                    { id: this.props.Id + "Tooltip" },
                    this.props.Tooltip
                );
            }

            var FieldNotFilled = "";
            if (this.props.FieldNotFilledHint && this.props.FieldNotFilledHint !== "") {
                FieldNotFilled = _react2.default.createElement(
                    'div',
                    { id: this.props.Id + "FieldNotFilled", className: "fieldNotFilled" },
                    this.props.FieldNotFilledHint
                );
            }

            var Style = null;

            if (this.props.Width) {
                Style = { width: this.props.Width, float: this.props.Float };
            }

            var StyleLabel = Style;
            if (this.props.LabelHeight) {
                StyleLabel = { width: this.props.Width, float: this.props.Float, height: this.props.LabelHeight };
            }

            var readOnly = false;
            var controlClassName = "textfield";
            var isTextFieldFilled = true;
            if (this.state.editable) {
                if (this.state.isrequired) {
                    if (this.state.required) {
                        controlClassName = "textfield";
                    } else {
                        controlClassName = "textfieldNotFilled";
                        isTextFieldFilled = false;
                    }
                } else {
                    controlClassName = "textfield";
                }
            } else {
                controlClassName = "textfieldDisabled";
                readOnly = true;
            }

            var icon = '';
            if (this.state.Icon) {
                var len = document.getElementById(this.props.Id).offsetWidth;
                if (this.state.Icon === "Close") {
                    icon = _react2.default.createElement(_Icon2.default, {
                        Name: this.state.Icon,
                        Size: 18,
                        Color: "black",
                        Align: "right",
                        OnClick: function OnClick() {
                            if (_this3.state.ClearFunction) {
                                if (typeof _this3.state.ClearFunction === "function") {
                                    _this3.state.ClearFunction();
                                }
                            } else {
                                _this3.Clear();
                            }
                        },
                        PaddingLeft: "" + (len - 25) + "px",
                        AppURL: this.props.AppURL });
                } else {
                    icon = _react2.default.createElement(_Icon2.default, {
                        Name: this.state.Icon,
                        Size: 18,
                        Color: "black",
                        Align: "left",
                        PaddingLeft: "" + (len - 25) + "px",
                        AppURL: this.props.AppURL });
                }
            }

            var loading = '';
            if (this.state.Loading) {
                if (this.state.Loading === false) {
                    loading = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'label',
                            {
                                htmlFor: this.props.Id },
                            _react2.default.createElement('div', {
                                id: this.props.Id + "Loading",
                                className: 'hide',
                                float: 'right' })
                        )
                    );
                } else {
                    loading = _react2.default.createElement(
                        'div',
                        { style: { float: "right", lineHeight: "30px", paddingRight: "20px" } },
                        _react2.default.createElement(
                            'label',
                            {
                                htmlFor: this.props.Id,
                                style: { float: "right", lineHeight: "30px", bottom: "20px", position: 'absolute' } },
                            _react2.default.createElement('div', {
                                id: this.props.Id + "Loading",
                                className: 'loaderComponent',
                                float: 'right' })
                        )
                    );
                }
            }

            var autocom = "off";

            if (this.state.autocomplete !== null) {
                if (this.state.autocomplete === true) {
                    autocom = "on";
                }
            }

            var isTextFieldFilledStyle = { visibility: 'hidden' };

            if (!isTextFieldFilled) {
                isTextFieldFilledStyle = { visibility: 'visible' };
            }

            var hintAutoCompleteStyle = { visibility: 'hidden', width: '82% !important' };

            if (this.state.HintAutoComplete !== null && this.state.HintAutoComplete !== undefined) {
                hintAutoCompleteStyle = { visibility: 'visible', width: '82% !important' };
            }

            var HintAutoComplete = this.state.HintAutoComplete;

            return _react2.default.createElement(
                'div',
                { style: Style },
                _react2.default.createElement(
                    'label',
                    {
                        className: 'textfieldLabel',
                        style: StyleLabel,
                        'for': this.props.Id,
                        id: this.props.Id + "Label" },
                    this.state.Label,
                    ' ',
                    Tooltip,
                    ' '
                ),
                _react2.default.createElement(
                    'div',
                    { id: this.props.Id + "HintAutoComplete", className: 'textfieldLabel', style: hintAutoCompleteStyle },
                    HintAutoComplete
                ),
                _react2.default.createElement(
                    'div',
                    { className: "autocomplete" },
                    _react2.default.createElement('input', {
                        readOnly: readOnly,
                        id: this.props.Id,
                        onBlur: function onBlur(e) {
                            if (_this3.props.Modus === "TariffPoint") {
                                if (_this3.props.OnBlur) {
                                    _this3.props.OnBlur();
                                }
                            } else {
                                _this3.tab(e, _this3);
                                if (_this3.props.OnBlur) {
                                    _this3.props.OnBlur();
                                }
                            }
                        },
                        onChange: function onChange() {
                            if (_this3.props.Modus === "Street") {
                                _this3.autocomplete(document.getElementById(_this3.props.Id), _this3.state.Data, _this3);
                            }

                            if (_this3.state.OnChange) {
                                if (_this3.Timeout !== '') {
                                    clearTimeout(_this3.Timeout);
                                }
                                var me = _this3;
                                _this3.Timeout = setTimeout(function () {
                                    me.state.OnChange();
                                }, _this3.state.TimeOutTime ? _this3.state.TimeOutTime : 1000);
                            }
                        },
                        onFocus: function onFocus() {
                            _this3.focus(_this3.props.Id);
                        },
                        placeholder: this.state.placeholder,
                        onKeyDown: function onKeyDown(e) {
                            if (e.keyCode === 9) {
                                e.preventDefault();
                            }_this3.tab(e, _this3);
                        },
                        type: 'text',
                        style: Style,
                        className: controlClassName,
                        autoComplete: autocom }),
                    _react2.default.createElement(
                        'label',
                        {
                            className: 'iconClass',
                            htmlFor: this.props.Id },
                        icon
                    ),
                    loading
                ),
                _react2.default.createElement(
                    'div',
                    { id: this.props.Id + "FieldNotFilled", style: isTextFieldFilledStyle },
                    FieldNotFilled
                )
            );
        }
    }]);

    return AutocompleteField;
}(_react.Component);

exports.default = AutocompleteField;